import { ReactNode } from 'react';
import { appPath } from '@/lib/basePath';

/**
 * Single centered auth card on the dark background. The marketing site sells;
 * these pages are just the door — logo above the card, form inside, links.
 * Card follows the redesign tokens: #0C0C10 surface, radius 20, inner
 * hairline instead of a border. `wide` is for public content pages (the coach
 * guide) that share the look but not the form width.
 */
export function AuthShell({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-surface0 text-white overflow-y-auto px-6 py-10 sm:px-10">
      <div className={`w-full ${wide ? 'max-w-[720px]' : 'max-w-[420px]'} page-enter`}>
        {/* Logo above the card */}
        <div className="flex flex-col items-center gap-3 mb-8">
          <div
            className="flex items-center justify-center bg-white rounded-2xl"
            style={{ width: 56, height: 56 }}
          >
            <img src={appPath('/logo.png')} alt="BMC" style={{ width: 40, height: 40, objectFit: 'contain' }} />
          </div>
          <span className="text-[15px] font-bold tracking-tight text-white/85">Brands Meet Creators</span>
        </div>

        {/* Card */}
        <div
          className="rounded-[20px] px-6 py-8 sm:px-8"
          style={{
            backgroundColor: '#0C0C10',
            boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.06)',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export function AuthHeading({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <div>
      <h1 className="text-[26px] font-extrabold tracking-tight leading-tight">{title}</h1>
      {subtitle && <p className="mt-2 text-white/55 text-[15px]">{subtitle}</p>}
    </div>
  );
}
